import { useState } from "react";

interface OrganizationDescriptionStepProps {
  onSubmit: (description: string) => void;
  onSkip: () => void;
  submitPartnerOnly?: boolean;
}

export const OrganizationDescriptionStep = ({
  onSubmit,
  onSkip,
  submitPartnerOnly,
}: OrganizationDescriptionStepProps) => {
  const [description, setDescription] = useState("");

  return (
    <div className="step-content step-8">
      <div className="step-header">
        <p className="step-subtitle">Create your organisation</p>
        <h2 className="step-title">Add a description</h2>
      </div>

      <div className="form-group">
        <textarea
          placeholder="Add a description"
          className="form-textarea"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={8}
        />
      </div>

      <button
        type="button"
        className="submit-button"
        onClick={() => onSubmit(description)}
      >
        Continue
      </button>

      {!submitPartnerOnly && (
        <button type="button" className="skip-button" onClick={onSkip}>
          Skip this step
        </button>
      )}
    </div>
  );
};
